import React from 'react'
import { Box } from '@mui/material'
import type { DropzoneRootProps } from 'react-dropzone'

type TransmissionPJDropAreaProps = {
    rootProps: DropzoneRootProps
    className: string
    style: React.CSSProperties
    children: React.ReactNode
}

const TransmissionPJDropArea = ({ rootProps, className, style, children }: TransmissionPJDropAreaProps) => (
    <Box {...rootProps} className={className} style={style} role="button" tabIndex={0}>
        {children}
    </Box>
)

export default TransmissionPJDropArea
